import { isNullOrUndefined } from "./validators";

export const formatDegreesToCompass = (degrees: number): string => {
  if (isNullOrUndefined(degrees)) return "N/A";
  if (degrees < 0 || degrees >= 360) return "N/A";
  const directions = [
    "N",
    "NNE",
    "NE",
    "ENE",
    "E",
    "ESE",
    "SE",
    "SSE",
    "S",
    "SSW",
    "SW",
    "WSW",
    "W",
    "WNW",
    "NW",
    "NNW",
    "N",
  ];
  const index = Math.round(degrees / 22.5) % 16;
  return directions[index];
};

export const degreesToRadians = (degrees: number) => {
  return (degrees * Math.PI) / 180;
};

export const polarToCartesian = (
  centerX: number,
  centerY: number,
  radius: number,
  angleInDegrees: number
): { x: number; y: number } => {
  const angleInRadians = degreesToRadians(angleInDegrees);

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
};

export const formatLatLongToDMS = (
  latitude: number,
  longitude: number
): string => {
  if (isNullOrUndefined(latitude) || isNullOrUndefined(longitude)) return "N/A";

  const latDegrees = Math.floor(Math.abs(latitude));
  const latMinutes = Math.floor((Math.abs(latitude) - latDegrees) * 60);
  const latSeconds = (
    (Math.abs(latitude) - latDegrees - latMinutes / 60) *
    3600
  ).toFixed(2);

  const longDegrees = Math.floor(Math.abs(longitude));
  const longMinutes = Math.floor((Math.abs(longitude) - longDegrees) * 60);
  const longSeconds = (
    (Math.abs(longitude) - longDegrees - longMinutes / 60) *
    3600
  ).toFixed(2);

  const latDirection = latitude >= 0 ? "N" : "S";
  const longDirection = longitude >= 0 ? "E" : "W";

  return `${latDegrees}° ${latMinutes}' ${latSeconds}" ${latDirection}, ${longDegrees}° ${longMinutes}' ${longSeconds}" ${longDirection}`;
};

export const convertUnixMicrosecondsToDate = (
  unixMicroseconds: string | null
): Date | null => {
  if (!unixMicroseconds || isNullOrUndefined(unixMicroseconds)) return null;

  const unixMilliseconds = parseInt(unixMicroseconds, 10) / 1000;
  return new Date(unixMilliseconds);
};
